import {lazy} from 'react';

export const PdfLibraryLazy = lazy(() => import(/* webpackChunkName: "pdfLibrary" */ '.'));
